import { useMutation, useQuery } from 'react-query';
import queryGetToken from './queries/queryGetToken';
import mutationUpdateToken from './mutations/mutationUpdateToken';


const actionsPreLogin = {
    fetchToken: (tokenUuid) => useQuery(queryGetToken(tokenUuid)),
    updateToken: (onSuccess, onError) => useMutation(mutationUpdateToken(onSuccess, onError))
};

export default actionsPreLogin;